import "./App.css";
import React, { useMemo, useState } from 'react';
import BaseRoutingPage from "./routes/BaseRoutingPage";
import AdminRoutingPage from "./routes/AdminRoutingPage.jsx";
import SchoolRoutingPage from "./routes/SchoolRoutingPage.jsx";
import FacultyRoutingPage from "./routes/FacultyRoutingPage";
import { AppContext } from "./context.js";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router } from "react-router-dom";
import { sanitizeInputValue } from "./utils/inputSanitizer";


function App() {
  const [fieldName, setFieldName] = useState({ name: 'thi is name' });
  const [videoData, setVideoData] = useState([])
  const [sectionId, setSectionId] = useState(null);
  const appContextValue = useMemo(
    () => ({ fieldName, setFieldName, videoData, setVideoData, sectionId, setSectionId }),
    [fieldName, videoData, sectionId]
  );

  const handleGlobalInputSanitize = (event) => {
    const target = event.target;
    if (!target) return;

    const tag = String(target.tagName || "").toLowerCase();
    if (tag !== "input" && tag !== "textarea") return;

    const fieldType = tag === "textarea" ? "textarea" : String(target.type || "text").toLowerCase();
    const maxLength = Number(target.maxLength) > 0 ? Number(target.maxLength) : undefined;
    const nextValue = sanitizeInputValue(String(target.value || ""), {
      type: fieldType,
      name: String(target.name || target.id || ""),
      maxLength,
    });

    if (nextValue === target.value) return;
    target.value = nextValue;
    target.dispatchEvent(new Event("input", { bubbles: true }));
  };


  return (
      <Provider store={store}>
      <Router basename="/">
        <div className="App" onInputCapture={handleGlobalInputSanitize}>
          <AppContext.Provider value={appContextValue}>
            <ToastContainer theme="colored" style={{ zIndex: 999999 }} />
            <BaseRoutingPage />
            <AdminRoutingPage />
            <SchoolRoutingPage />
            <FacultyRoutingPage />
          </AppContext.Provider>
        </div>
      </Router>
      </Provider>
  );
}

export default App;
